module.exports = __webpack_public_path__ + "assets/img/snapchat.a78ba622.png";